export const LOGIN = '/login';
export const RESET_PASSWORD = '/password/reset';
export const REGISTER_PASSWORD = '/password/register';
